import { useEffect, useState } from 'react';
import InputModal from '../modals/InputModal';
import type { PromptOptions } from '../../lib/ui';

type Pending = {
  opts: PromptOptions;
  resolve: (v: string | null) => void;
} | null;

// Global host for askPrompt() (lib/ui) — renders the in-app InputModal so text
// prompts work everywhere, including the desktop (.exe) build where window.prompt()
// is a no-op. Mounted once in AppProviders alongside ToastHost/ConfirmHost.
export default function PromptHost() {
  const [pending, setPending] = useState<Pending>(null);
  useEffect(() => {
    function onPrompt(e: Event) {
      const ce = e as CustomEvent;
      const { opts, resolve } = ce.detail || {};
      if (!resolve) return;
      setPending({ opts: opts || {}, resolve });
    }
    window.addEventListener('ui:prompt', onPrompt as EventListener);
    return () => window.removeEventListener('ui:prompt', onPrompt as EventListener);
  }, []);
  if (!pending) return null;
  const o = pending.opts;
  return (
    <InputModal
      open={true}
      title={o.title}
      label={o.label}
      placeholder={o.placeholder}
      initialValue={o.initialValue}
      okText={o.okText}
      cancelText={o.cancelText}
      textarea={o.textarea}
      onSubmit={(value) => { pending.resolve(value); setPending(null); }}
      onCancel={() => { pending.resolve(null); setPending(null); }}
    />
  );
}
